export interface IProperty {
    id: string;
    name: string;
    purchaseDetails: IPurchaseDetail[];
    /**
     * @deprecated Use {@link IProperty.purchaseDetails} instead
     */
    price?: number;
    countyTaxRate: number;
    /**
     * @deprecated Use {@link IProperty.purchaseDetails} instead
     */
    userTaxRate?: number;
    /**
     * @deprecated Use {@link IProperty.purchaseDetails} instead
     */
    monthlyHomeInsurance?: number;
    monthlyAssociationFee: number;
    county: string;
    countyType: string;
    zip: string;
    city: string;
    state: string;
    address: string;
    addressDisplay: string | null;
    fip: string;
    appreciationType: TAppreciation;
    appreciationTypes: TAppreciationTypes;
    customAppreciation: number;
    forecastData: IForecastData[];
    historicalData: IHistoricalData[];
    actualHistoricalData: IForecastData[];
    medianHomePrice: number;
    longitude: string;
    latitude: string;
    route: string;
    streetNumber: string;
    apartment: string;
    userEstimatedValue: number | null;
    // month: 1 - 12, year: 2023
    purchaseDate: { month: number; year: number };
    costToSell: number;
    image: string;
    monthlyAllow: number;
    repairs: number;
    initialRenovationCost: number;
    taxInc: number;
    /** @deprecated Instead use userMonthlyRent for direct access, or monthlyRent from the enhancedProperty */
    monthlyRent: number;
    rentIns: number;
    rentInc: number;
    propertyManagementFee: number;
    avgAnnualVacancy: number;
    rentSqFt: number;
    buySqFt: number;
    userAppraisedValue: number | null;
    userMonthlyRent: number | null;
}

export interface IPurchaseDetail {
    id: string;
    price: number;
    userMonthlyHomeInsurance: number | null;
    monthlyHomeInsurance: number;
    userTaxRate: number | null;
    bidOver: number;
}

export const APPRECIATION = Object.freeze({
    FORECAST: "forecast",
    HISTORICAL: "historical",
    HISTORICAL_5: "historical5",
    HISTORICAL_10: "historical10",
    CUSTOM: "custom",
});

export type TAppreciation = (typeof APPRECIATION)[keyof typeof APPRECIATION];
export type TAppreciationTypes = (typeof APPRECIATION)["FORECAST" | "HISTORICAL" | "CUSTOM"][];

export interface IForecastData {
    fip?: number;
    zip?: number;
    date: string;
    tier1: number;
    tier2: number;
    tier3: number;
    tier4: number;
    tier5: number;
    type: string;
}

export interface IHistoricalData {
    fip: number;
    years: number;
    histAppr: number;
    type: string;
}
